import { useTheme } from '@mui/styles';

import {
  DRAWER_CLOSE_WIDTH_PX,
  DRAWER_OPEN_WIDTH_PX,
} from '~/features/Sidebars/LeftSideMenu/useStyles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      height: '100%',
      width: '100%',
      maxHeight: '100%',
    },
    workspaceLayout: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    widgets: {
      flexGrow: 1,
      overflowY: 'auto',
    },
    marginOpen: { marginLeft: DRAWER_OPEN_WIDTH_PX },
    marginClose: { marginLeft: DRAWER_CLOSE_WIDTH_PX },
    actions: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(),
    },
    sidebar: {
      position: 'absolute',
      height: '100%',
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
      overflow: 'hidden',
      position: 'relative',
      height: '100%',
    },
    greeting: {
      backgroundColor: 'white',
      margin: '16px 16px 0px 16px',
      cursor: 'none',
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          border: '1px solid black',
        },
        '&:hover fieldset': {
          border: '1px solid black',
        },
        '&.Mui-focused fieldset': {
          border: '1px solid black',
        },
      },
    },
    greetingText: {
      fontWeight: 'bold',
      fontSize: '1.5rem',
    },
  };
};
